import { ICardNameWidth } from './types';
import { CARD_NAME_WIDTH_SESSIONSTORAGE } from './constants';

export const setCardNameWidth = (data: ICardNameWidth) => {
    sessionStorage.setItem(CARD_NAME_WIDTH_SESSIONSTORAGE, JSON.stringify(data));
}
